import template from './is-occupied.jade';

export default angular
  .module('cian.addForm.isOccupied', ['cian.addForm.fieldTypeSwitcher'])
  .directive('cianAfAboutObjectIsOccupied', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller() {
      this.items = [
        {
          text: 'Да',
          value: true,
        },
        {
          text: 'Нет',
          value: false,
        },
      ];
    },
    controllerAs: 'isOccupied',
    template,
  })).name;
